module.exports = __webpack_public_path__ + "static/media/Background7.11cc72c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Backgrounds/Background7.png
// module id = 257
// module chunks = 0